import * as React from 'react';
import { useIntl } from 'react-intl';
import DynamicTable from '../DynamicTable';
import PermissionsService, {
  PERMISSION_GDPR_USER_CHANGE_PROFILE,
  PERMISSION_GDPR_USER_LIST,
} from '../../Services/PermissionsService';
import Form from './Form';
import { TABLE_GDPR_USER, TABLE_GDPR_USER_HISTORY } from '../../Services/TableService';
import TabComponent from '../TabComponent';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { URL_GDPR_USER } from '../../router/constants';
import { ITab } from '../TabComponent/interfaces';
import PageHeader from '../PageHeader';

const GDPR_USER_HISTORY_URL = '/gdpr-user/history';

export const tabsByPermission = (tabs: string[], active: string): ITab[] => {
  const enabledTabs: ITab[] = [];
  tabs.forEach((tabItem: string) => {
    if (
      tabItem === TABLE_GDPR_USER &&
      PermissionsService.hasAccess(PERMISSION_GDPR_USER_LIST, ['read'])
    ) {
      enabledTabs.push({
        name: tabItem,
        isActive: tabItem === active,
        url: URL_GDPR_USER,
      });
    }
    if (
      tabItem === TABLE_GDPR_USER_HISTORY &&
      PermissionsService.hasAccess(PERMISSION_GDPR_USER_LIST, ['read'])
    ) {
      enabledTabs.push({
        name: tabItem,
        isActive: tabItem === active,
        url: GDPR_USER_HISTORY_URL,
      });
    }
  });
  return enabledTabs;
};

export default function GdprUsersList() {
  const { formatMessage: f } = useIntl();
  const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
  const [callTable, setCallTable] = React.useState<boolean>(false);
  const [itemId, setItemId] = React.useState<number | null>(null);
  const [options, setOptions] = React.useState<any>([]);
  const [customerId, setCustomerId] = React.useState<number | null>(null);
  const [fullname, setFullname] = React.useState<string>('');
  const [customerLabel, setCustomerLabel] = React.useState<string>('');
  const tabs = React.useState(
    tabsByPermission([TABLE_GDPR_USER, TABLE_GDPR_USER_HISTORY], TABLE_GDPR_USER)
  )[0];
  const documentTitle = `${f({ id: 'menu.gdprUsersList' })} - ${f({
    id: 'menu.gdpr',
  })}`;
  useDocumentTitle(documentTitle);

  const handleClose = () => {
    setIsModalOpened(false);
    setItemId(null);
  };

  const updateTable = () => {
    setCallTable(true);
  };

  const handleForm = (
    id: number,
    isEdited: boolean | string,
    customerValue: number,
    optionsData: any,
    name: string,
    label: string
  ) => {
    setIsModalOpened(true);
    setOptions(optionsData);
    setCallTable(false);
    setItemId(id);
    setCustomerId(customerValue);
    setFullname(name);
    setCustomerLabel(label);
  };

  const isUpdatingAllowed = PermissionsService.hasAccess(
    PERMISSION_GDPR_USER_CHANGE_PROFILE,
    ['update'],
    null
  );

  return (
    <>
      <PageHeader
        title={`${f({ id: 'menu.gdpr' })} / ${f({ id: 'menu.gdprUsersList' })}`}
        onlineHelpTopic="gdpr-users"
      />
      <div className="pl-4 pr-4">
        <TabComponent tabs={tabs}>
          <div>
            <DynamicTable
              name={TABLE_GDPR_USER}
              mustClosed={true}
              updateTable={callTable}
              openForm={handleForm}
            />
          </div>

          {isModalOpened && isUpdatingAllowed && itemId && (
            <div>
              <Form
                closeCallback={handleClose}
                options={options}
                userIds={[itemId]}
                updateTable={updateTable}
                customerId={customerId}
                customerLabel={customerLabel}
                fullname={fullname}
              />
            </div>
          )}
        </TabComponent>
      </div>
    </>
  );
}
